import { DateFormat, FormatFunction, Locale } from '@onereach/ui-components-25';

export const getUTCDate = (date?: Date, monthStep = 0): Date => {
  const baseDate = date ?? new Date();

  return new Date(Date.UTC(
    baseDate.getFullYear(),
    baseDate.getMonth() + monthStep,
    baseDate.getDate(),
  ));
};

export const notEmpty = (date: Date | '' | undefined) => date !== '' && Boolean(date);

export const getHumanFriendlyDate = (
  value: Date,
  format: `${DateFormat}` | FormatFunction<Date>,
  locale: Locale
): string => {
  return value.toLocaleString(locale, {
    dateStyle: 'short',
  });
};

export const getHours = (date: Date | '' | undefined) => {
  return notEmpty(date) ? (date as Date).getHours() : new Date().getHours();
};

export const getMinutes = (date: Date | '' | undefined) => {
  return notEmpty(date) ? (date as Date).getMinutes() : new Date().getMinutes();
};
